import {
  getAvailableSteps,
  getFeatureGroupFromWizardGroup,
  navItemIsExcluded,
  wizardGroupHasFeatureIncluded
} from "./lookWizardFunctions";
import Config, {getCommonVisualizerType, IS_QKB_UI} from "../../../../../config";
import {fixWizardItem} from "./wizardFunctionsCommon";
import {
  getVisualizerTypeFromSubscription,
  hasSubscriptionForRoom
} from "../../../../../misc/visualizerSwitchingFunctions";
import {CABINET_BOXES, SQFT_FEATURES} from "../../../../sqft/constants";

export const getWizardGroupName = (wizardGroup, featureGroup, quoteIndex) => {
  if (!wizardGroup) {
    return ""
  }
  if (featureGroup && featureGroup.customNames && Number.isInteger(quoteIndex) && featureGroup.customNames[quoteIndex]) {
    return featureGroup.customNames[quoteIndex]
  }
  return wizardGroup.title || wizardGroup.customDisplayName || wizardGroup.productCartTitle || wizardGroup.groupName || ""
  // if (stepName === "Vanitie") { // it should be renamed on the backend so no need for that
  //   stepName = "Vanity"
  // }
}

/**
 * this returns new wizard steps depending on the current selection
 * @param wizardActiveItem {wizardItemInterface}
 * @param currentStep {number}
 * @param allWizardSelectedValues {object}
 * @returns {object}
 */
export const getNextWizardSteps = (wizardActiveItem, currentStep, allWizardSelectedValues) => {
// const oldWizardSteps = getAvailableSteps(wizardActiveItem, oldWizardSelectedValues, true);

  let newValues = {};
  Object.keys(allWizardSelectedValues).forEach(key => {
    if (+key <= currentStep) {
      newValues[key] = allWizardSelectedValues[key] // here we create values object just until the current selected value
    }
  });

  const afterCurrentSelectionWizardSteps = getAvailableSteps(wizardActiveItem, newValues, true, allWizardSelectedValues);
  // const allWizardSteps = getAvailableSteps(wizardActiveItem, allWizardSelectedValues, true);

  // const nextStep = currentStep + 1;

  // if (
  //   afterCurrentSelectionWizardSteps[nextStep] && allWizardSteps[nextStep]
  //   && afterCurrentSelectionWizardSteps[nextStep].stepGroups.every((wizardGroup, wizardGroupIndex) => {
  //     return allWizardSteps[nextStep].stepGroups[wizardGroupIndex] && wizardGroup.id === allWizardSteps[nextStep].stepGroups[wizardGroupIndex].id
  //   }) && (allWizardSelectedValues[nextStep] && allWizardSelectedValues[nextStep].wizardGroup
  //     && afterCurrentSelectionWizardSteps[nextStep].stepGroups.some(wizG => allWizardSelectedValues[nextStep].wizardGroup.id === wizG.id))
  // ) {
  //   return allWizardSteps // keep it, as we didn't change the flow
  // }

  return afterCurrentSelectionWizardSteps // use new ones, as the flow was changed

}

const buildConflictingObject = (cartItem, wizardActiveItem, withCartFeature) => {
  const wg = wizardActiveItem.wizardGroups.find(wg => wg.id === cartItem.fromWizardGroupId);

  const conflictingObject = {
    stepIndex: cartItem.fromWizardStep,
    wizardGroupId: cartItem.fromWizardGroupId,
    wizardItemHashId: wizardActiveItem.uniqueHashId,
    wizardGroupGroupName: wg?.groupName,
    cartItemId: cartItem.id,
  };

  if (withCartFeature) {
    conflictingObject.cartFeature = cartItem.cartFeature;
  }

  return conflictingObject;
};

const addCrownMoldingConflictsForTopCabinet = ({
                                                 cartItem,
                                                 cartItemsWithoutExceptions,
                                                 conflictingWizardSteps,
                                                 wizardActiveItem,
                                                 withCartFeature,
                                               }) => {
  if (cartItem.partId !== SQFT_FEATURES.top_cabinet) {
    return;
  }

  cartItemsWithoutExceptions.forEach(relatedCartItem => {
    if (relatedCartItem.partId !== SQFT_FEATURES.crown_molding) {
      return;
    }

    if (relatedCartItem.currentQuote !== cartItem.currentQuote) {
      return;
    }

    if (relatedCartItem.fromWizardId !== cartItem.fromWizardId) {
      return;
    }

    if (relatedCartItem.bundleParentId) {
      return;
    }

    if (conflictingWizardSteps.some(confObject => confObject.cartItemId === relatedCartItem.id)) {
      return;
    }

    conflictingWizardSteps.push(
      buildConflictingObject(relatedCartItem, wizardActiveItem, withCartFeature),
    );
  });
};

/**
 * this returns conflicting with the current selections steps
 * 1) excludes EXCEPTIONS
 * 2) adds crown_molding conflict for the top cabinets
 * @param allWizardSelectedValues {object}
 * @param actionPayload {object} // {wizardActiveItem, quoteIndex}
 * @param cartItems {[cartItemInterface]}
 * @param newWizardSteps {[]}
 * @param withCartFeature {boolean}
 * @returns {array}
 */
export const getConflictingWizardSteps = (
  allWizardSelectedValues,
  actionPayload,
  cartItems,
  newWizardSteps,
  withCartFeature = false,
) => {
  const { wizardActiveItem, quoteIndex } = actionPayload;

  const currentStep = +Object.keys(actionPayload.wizardSelectedValues)[0];
  let conflictingWizardSteps = [];

  const cartItemsWithoutExceptions = cartItems.filter(cartItem => {
    const EXCEPTIONS = [SQFT_FEATURES.slabs, ...CABINET_BOXES, 'installation'];

    return !EXCEPTIONS.includes(cartItem.partId);
  });

  cartItemsWithoutExceptions.forEach(cartItem => {
    if (!cartItem.fromWizardGroupId
      || !Number.isInteger(cartItem.fromWizardStep)
      || !cartItem.fromWizardId
      || (cartItem.currentQuote !== quoteIndex)
      || (cartItem.fromWizardId !== wizardActiveItem.id)
      || cartItem.bundleParentId
    ) {
      return false;
    }

    if ((Object.keys(allWizardSelectedValues).length - 1) === cartItem.fromWizardStep
      && (cartItem.fromWizardStep === currentStep)
    ) {
      return false;
    }

    if (conflictingWizardSteps.some(confObject => confObject.cartItemId === cartItem.id)) {
      return false;
    }

    if (!newWizardSteps.some(step => {
        return step.stepGroups.some(wizardGroup => (wizardGroup.id === cartItem.fromWizardGroupId)
          || (wizardGroup.mergedGroups && wizardGroup.mergedGroups.length
            && wizardGroup.mergedGroups.some(mG => mG.id === cartItem.fromWizardGroupId)))
      })
      || !newWizardSteps[cartItem.fromWizardStep]
    ) {
      conflictingWizardSteps.push(
        buildConflictingObject(cartItem, wizardActiveItem, withCartFeature),
      );

      addCrownMoldingConflictsForTopCabinet({
        cartItem, cartItemsWithoutExceptions, conflictingWizardSteps, wizardActiveItem, withCartFeature,
      });
    } else if (
      newWizardSteps[cartItem.fromWizardStep + 1]
      && newWizardSteps[cartItem.fromWizardStep + 1].stepGroups
    ) {
      // // here we check if some cart item is added, but his next steps are not anymore in the wizard
      //
      // // we need to get steps only for before current selected item
      // let testValues = {};
      // Object.keys(allWizardSelectedValues).forEach(key => {
      //   if (+key <= cartItem.fromWizardStep) {
      //     testValues[key] = allWizardSelectedValues[key] // here we create values object just until the current selected value
      //   }
      // });
      // const testWizardSteps = getNextWizardSteps(wizardActiveItem, cartItem.fromWizardStep, testValues);
      //
      // const testGroups = testWizardSteps[cartItem.fromWizardStep + 1] ? testWizardSteps[cartItem.fromWizardStep + 1].stepGroups : null;
      // const sameGroupsNew = newWizardSteps[cartItem.fromWizardStep + 1] ? newWizardSteps[cartItem.fromWizardStep + 1].stepGroups : null;
      //
      // if (testGroups && testGroups.length && sameGroupsNew && sameGroupsNew.length && ((sameGroupsNew.length !== testGroups.length)
      //   || sameGroupsNew.some((wizardGroup, wizardGroupIndex) => wizardGroup.id !== testGroups[wizardGroupIndex].id))) {
      //   conflictingWizardSteps.push({
      //     stepIndex: cartItem.fromWizardStep,
      //     wizardGroupId: cartItem.fromWizardGroupId,
      //     cartItemId: cartItem.id,
      //   });
      // }
    }
  });

  // get current selected wizard value and check if the next one is conflicting - then add the current one to, because it cases the issue
  // !commented out because room was added to conflicting steps

  // const nextStepKey = currentStep + 1;
  // if (conflictingWizardSteps.some(confObject => confObject.stepIndex === nextStepKey)) {
  //   cartItems.forEach(cartItem => {
  //     if (!cartItem.fromWizardGroupId || (cartItem.currentQuote !== quoteIndex) || (cartItem.fromWizardId !== wizardActiveItem.id)) {
  //       return false
  //     }
  //     if (conflictingWizardSteps.some(confObject => confObject.cartItemId === cartItem.id)) { // already added
  //       return false
  //     }
  //     // no more step with this cart item
  //     if (cartItem.fromWizardStep === currentStep) {
  //       let conflictingObject = {
  //         stepIndex: cartItem.fromWizardStep,
  //         wizardGroupId: cartItem.fromWizardGroupId,
  //         cartItemId: cartItem.id,
  //       };
  //       if (withCartFeature) {
  //         conflictingObject.cartFeature = cartItem.cartFeature;
  //       }
  //       conflictingWizardSteps.unshift(conflictingObject);
  //     }
  //   });
  // }

  // console.log("newWizardSteps", newWizardSteps);
  // console.log("conflictingWizardSteps", conflictingWizardSteps);

  return conflictingWizardSteps;
};

/**
 * Re-links existing cart items to equivalent groups in the newly available wizard flow.
 *
 * @param newWizardSteps {array}
 * @param actionPayload {object} // {wizardActiveItem, quoteIndex}
 * @param cartItems {[cartItemInterface]}
 * @returns {object}
 */
export const switchCartItemsToNewWizardGroups = (newWizardSteps, actionPayload, cartItems) => {

  const {wizardActiveItem, quoteIndex} = actionPayload;

  let shouldReassign = false;

  const newCartItems = cartItems.map(cartItem => {
    // Items without a full wizard origin are skipped and must not trigger a conflict popup.
    // The popup cannot resolve them because it has no wizard step/group to route to.
    if (!cartItem.fromWizardGroupId
      || !Number.isInteger(cartItem.fromWizardStep)
      || !cartItem.fromWizardId
      || (cartItem.currentQuote !== quoteIndex) || (cartItem.fromWizardId !== wizardActiveItem.id)) {
      return cartItem
    }
    // no more step with this cart item
    if (!newWizardSteps.some(step => step.stepGroups.some(wizardGroup => wizardGroup.id === cartItem.fromWizardGroupId))
      || !newWizardSteps[cartItem.fromWizardStep]) {
      // here we check all next steps, if there are some step with the same wizardGroup, and it has the cartFeature navItem
      newWizardSteps.forEach(step => {
        if (!step.stepGroups || !step.stepGroups[0] || (step.stepGroups.length > 1)) {
          return
        }
        let testWizG = step.stepGroups[0];
        if (testWizG.groupName !== cartItem.cartFeature.dbFeature.groupName
          && !((cartItem.cartFeature.dbFeature.groupName === "Vanity") && (testWizG.groupName === "Vanitie"))
        ) {
          return;
        }
        const wizardGroupThatHasFeature = wizardGroupHasFeatureIncluded(testWizG, cartItem.cartFeature);
        if (wizardGroupThatHasFeature
          && (wizardGroupThatHasFeature.id !== cartItem.fromWizardGroupId
            || cartItem.fromWizardStep !== step.stepIndex)) {
          shouldReassign = true;
          cartItem.fromWizardStep = step.stepIndex;
          cartItem.fromWizardGroupId = wizardGroupThatHasFeature.id;
          console.log("cartItem changed!", cartItem);
        }
      })
    }
    return cartItem
  });

  return {newCartItems, shouldReassign}
}

export const selectedWizardGroupIsNotInCurrentStepAnymore = (selectedWizardValue, currentStepGroups) => {
  const stepWizGroup = currentStepGroups[0]; // could be merged
  const selectedWizardGroup = selectedWizardValue ? selectedWizardValue.wizardGroup : null;
  if (!selectedWizardGroup) {
    return Boolean(selectedWizardValue);
  }
  if (currentStepGroups.length > 1 && stepWizGroup && currentStepGroups.some(wG => wG.id === selectedWizardGroup.id)) {
    return false
  }
  return selectedWizardGroup && stepWizGroup && (selectedWizardGroup.id !== stepWizGroup.id)
    && (!stepWizGroup.mergedGroups || !stepWizGroup.mergedGroups.length
      || !stepWizGroup.mergedGroups.some(mG => mG.id === selectedWizardGroup.id))
}

/**
 * this returns conflicting with the current selections steps
 * @param newWizValues {object}
 * @param newWizardSteps {array}
 * @param isModalFixOpen {boolean}
 // * @param cartItems {[cartItemInterface]}
 * @returns {object}
 */
export const changeWizardValuesToUseNewGroups = (newWizValues, newWizardSteps, isModalFixOpen) => {

  let shouldReassignValues = false;
  let updatedWizardValues = Object.assign({}, newWizValues);

  Object.keys(updatedWizardValues).forEach(key => { // here we replace wizard values to match new selections! to prevent conflicting
    // if there are no wizardGroup anymore in the next flow, but it was selected earlier - set new wizardGroup
    if (updatedWizardValues[key].wizardGroup
      && updatedWizardValues[key].selectedFeature
      && !newWizardSteps.some(step => (step.stepGroups.length === 1) && (step.stepGroups[0].id === updatedWizardValues[key].wizardGroup.id))
      && (newWizardSteps[key] && newWizardSteps[key].stepGroups && (newWizardSteps[key].stepGroups.length === 1)
        && (updatedWizardValues[key].wizardGroup.groupName === newWizardSteps[key].stepGroups[0].groupName)
        && !navItemIsExcluded({part: updatedWizardValues[key].selectedFeature}, newWizardSteps[key].stepGroups[0])
      )) {
      shouldReassignValues = true;
      updatedWizardValues[key].wizardGroup = newWizardSteps[key].stepGroups[0];
      // console.log("wizardGroup updated!", updatedWizardValues[key]);
    }
  });

  const erasedValues = {};

  // here we go through all new wizard steps - and check old values - if there are something selected and it is not
  // anymore in the flow - but there is a step - assign new wizard selected value
  newWizardSteps.forEach(newWizardStep => {
    if (newWizardStep.stepGroups.length !== 1 || newWizardStep.stepGroups[0].nodeType !== "group") {
      return
    }
    const stepWizGroup = newWizardStep.stepGroups[0]; // could be merged
    if (!updatedWizardValues[newWizardStep.stepIndex] ||
      (updatedWizardValues[newWizardStep.stepIndex]
        && updatedWizardValues[newWizardStep.stepIndex].wizardGroup
        && (updatedWizardValues[newWizardStep.stepIndex].wizardGroup.groupName !== stepWizGroup.groupName
          // we still need to get inside if group is not valid - to erase it as we don't need it! we will assign a new one below if needed
          || selectedWizardGroupIsNotInCurrentStepAnymore(updatedWizardValues[newWizardStep.stepIndex], newWizardStep.stepGroups))
      )) {
      // we have a step and the value selected is incorrect - go ahead and find something similar
      let updated = false;
      if (isModalFixOpen) {
        shouldReassignValues = true;
      }
      Object.keys(newWizValues).forEach(key => { // here we replace wizard values to match new selections! to prevent conflicting
        // if there are no wizardGroup anymore in the next flow, but it was selected earlier - set new wizardGroup
        if (newWizValues[key].wizardGroup
          && newWizValues[key].selectedFeature
          && newWizValues[key].wizardGroup.groupName === stepWizGroup.groupName
          && (!newWizardSteps[key] || (newWizardSteps[key].stepGroups.length !== 1) || newWizValues[key].wizardGroup.groupName !== newWizardSteps[key].stepGroups[0].groupName)
          && !navItemIsExcluded({part: newWizValues[key].selectedFeature}, stepWizGroup)) {

          shouldReassignValues = true;
          erasedValues[newWizardStep.stepIndex] = Object.assign({}, updatedWizardValues[newWizardStep.stepIndex]); // save it first, to restore below
          updatedWizardValues[newWizardStep.stepIndex] = Object.assign({}, newWizValues[key], {
            wizardGroup: stepWizGroup,
          });
          updated = true;
          // updatedWizardValues[key] = {}; // clear old step
          // console.log("wizardGroup updated throw all steps search!", updatedWizardValues[key]);
        }
      });
      if (!updated) {
        erasedValues[newWizardStep.stepIndex] = Object.assign({}, updatedWizardValues[newWizardStep.stepIndex]); // save it first, to restore below
        updatedWizardValues[newWizardStep.stepIndex] = {};
        delete updatedWizardValues[newWizardStep.stepIndex];
      }
    }
  });

  // console.log("erasedValues", erasedValues);

  // 3) here we go through again through steps and check if we erased something but it exist in the next flow
  newWizardSteps.forEach(newWizardStep => {
    if (newWizardStep.stepGroups.length !== 1 || newWizardStep.stepGroups[0].nodeType !== "group") {
      return
    }
    const stepWizGroup = newWizardStep.stepGroups[0]; // could be merged
    if (!updatedWizardValues[newWizardStep] || !updatedWizardValues[newWizardStep].wizardGroup) {
      Object.keys(erasedValues).forEach(key => {
        if (erasedValues[key].wizardGroup && erasedValues[key].selectedFeature
          && (erasedValues[key].wizardGroup.groupName === stepWizGroup.groupName)
          && !navItemIsExcluded({part: erasedValues[key].selectedFeature}, stepWizGroup)) {
          updatedWizardValues[newWizardStep.stepIndex] = Object.assign({}, newWizValues[key], {
            wizardGroup: stepWizGroup,
          });
          // console.log("USE ERASED LOGIC", updatedWizardValues[newWizardStep.stepIndex]);
          erasedValues[key] = {}; // use it only once! then delete
        }
      })
    }
  });

  // now go again and set missing wizard groups
  Object.keys(updatedWizardValues).forEach(key => {
    if (!updatedWizardValues[key] || !updatedWizardValues[key].wizardGroup || !newWizardSteps[key]
      || !newWizardSteps[key].stepGroups.length || (newWizardSteps[key].stepGroups.length !== 1)) { // we set wizard group only if the next one is selected
      return
    }
    // const nextSelectedValue = updatedWizardValues[key + 1];
    // const selectedWizGroup = updatedWizardValues[key].wizardGroup;
    const newWizGroup = newWizardSteps[key].stepGroups[0];

    if (selectedWizardGroupIsNotInCurrentStepAnymore(updatedWizardValues[key], newWizardSteps[key].stepGroups)) {
      // set wizard group as we might have cart items added to this group, we can't have it disabled
      updatedWizardValues[key] = {
        wizardGroup: newWizGroup
      }
    }
  });

  //last update - make sure that every wizard group is selected if we have cart item in the group below
  // const lastSelectedStep = Object.keys(updatedWizardValues).reverse().find(lastKey => updatedWizardValues[lastKey] && updatedWizardValues[lastKey].wizardGroup);
  Object.keys(updatedWizardValues).forEach(key => {
    if (!updatedWizardValues[key].wizardGroup && newWizardSteps[key] && newWizardSteps[key].stepGroups.length
      && (newWizardSteps[key].stepGroups.length === 1) && updatedWizardValues[+key + 1] && updatedWizardValues[+key + 1].wizardGroup) {
      // we set wizard group only if the next one is selected
      updatedWizardValues[key] = {
        wizardGroup: newWizardSteps[key].stepGroups[0]
      }
    }
  });

  return {updatedWizardValues, shouldReassignValues}
}

/**
 * @param partId {string}
 * @param featureGroup {featureGroupInterface}
 * @param isBathroom {boolean}
 * @returns {boolean}
 */
const checkFeatureGroupForOpposite = (partId, featureGroup, isBathroom) => {
  switch (partId) {
    case "backsplash":
      return isBathroom && (featureGroup.partId === "vanity_backsplash")
    case "center_island_edge":
      return featureGroup.partId === "edge_profile"
    case "edge_profile":
      return featureGroup.partId === "center_island_edge"
    case "countertop":
      return (featureGroup.partId === "center_island_countertop") || (isBathroom && (featureGroup.partId === "vanity_countertop"))
    case "center_island_countertop":
      return (featureGroup.partId === "countertop") || (isBathroom && (featureGroup.partId === "vanity_countertop"))
    case "corners":
      return featureGroup.partId === "radius"
    default:
      return featureGroup.partId === partId
  }
}

/**
 * @param wizardSteps {array}
 * @param cartItem {cartItemInterface}
 * @returns foundStep {object}
 */
export const getWizardStepFromCartItemFeature = (wizardSteps, cartItem) => {
  let foundStep = wizardSteps.find(step => step.stepGroups.some(wizardGroup => {
    const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
    return featureGroup && featureGroup.partId === cartItem.partId
  }));
  if (!foundStep) {
    const isBathroom = getCommonVisualizerType() === "bathroom";
    foundStep = wizardSteps.find(step => step.stepGroups.some(wizardGroup => {
      const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
      if (!featureGroup) {
        return false
      }
      return checkFeatureGroupForOpposite(cartItem.partId, featureGroup, isBathroom)
    }));
  }
  return foundStep
}

/**
 * @param wizardSteps {array}
 * @param partId {string}
 * @returns {object}
 */
export const getFeatureGroupFromWizardSteps = (wizardSteps, partId) => {
  for (const step of wizardSteps) {
    for (const wizardGroup of step.stepGroups) {
      const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
      if (featureGroup && featureGroup.partId === partId) {
        return {part: featureGroup}
      }
    }
  }
  const isBathroom = getCommonVisualizerType() === "bathroom";
  for (const step of wizardSteps) {
    for (const wizardGroup of step.stepGroups) {
      const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
      if (featureGroup && checkFeatureGroupForOpposite(partId, featureGroup, isBathroom)) {
        return {part: featureGroup}
      }
    }
  }
}

const parseWizardData = (wizardData) => {
  let allItems = typeof wizardData === "string" ? JSON.parse(wizardData) : [];
  if (typeof wizardData === "object" && (wizardData != null)) {
    Object.keys(wizardData).forEach(key => {
      allItems = [...allItems, ...JSON.parse(wizardData[key])]
    });
  }
  return allItems
}

/**
 * @param mainResponse
 * @param parseOnly {boolean}
 * @param newVisualizerType {string}
 * @returns {array}
 */
export const getParsedWizardList = (mainResponse, parseOnly, newVisualizerType = "") => {
  const {wizardData, wizardDataV2} = mainResponse;
  const allItems = parseWizardData(wizardDataV2 || wizardData); // if we have v2 - use it, else old support
  if (Config.isDevMode()) {
    console.log("all wizardItems ", allItems);
  }
  let filtered = allItems.filter(wizardItem => wizardItem.enabled && !(wizardItem.hideForQuoting && IS_QKB_UI))
  if (parseOnly) {
    return filtered
  }
  const wizardList = filtered
      .map((wizardItem, wizardItemIndex) => {
        wizardItem = fixWizardItem(wizardItem, wizardItemIndex, false, newVisualizerType);
        if (wizardItem.visualizer === "all") {
          wizardItem.visualizer = getCommonVisualizerType(newVisualizerType); // we keep same wizard as different
          wizardItem.id = wizardItem.id + 100;
        }
        wizardItem.id = getUpdatedWizardId(wizardItem.visualizer, wizardItem.id);
        return wizardItem
      });
  console.log("wizardList", wizardList);
  return wizardList
}

/**
 * same function for wizard item and cart item on parse - it returns new wizard id depending on the visualizer
 * @param visualizerType {string}
 * @param oldWizardItemId {number}
 * @returns {number}
 */
export const getUpdatedWizardId = (visualizerType, oldWizardItemId) => {
  switch (getCommonVisualizerType(visualizerType)) {
    case "laundryroom":
      if (oldWizardItemId < 3000) {
        return oldWizardItemId + 3000 // increase because we don't want to have same id's
      }
      break;
    case "fireplace":
      if (oldWizardItemId < 2000) {
        return oldWizardItemId + 2000 // increase because we don't want to have same id's
      }
      break;
    case "bathroom":
      if (oldWizardItemId < 1000) {
        return oldWizardItemId + 1000 // increase because we don't want to have same id's
      }
      break;
    default:
      return oldWizardItemId // keep as is for kitchen
  }
  return oldWizardItemId
}

/**
 * returns lowercased visualizer (bathroom | kitchen | fireplace) same as in the wizard item depending on wizardItem id
 * @param ci {cartItemInterface}
 * @param wizardState {object}
 * @returns {cartItemInterface}
 */
export const updateCartItemWizardValues = (ci, wizardState) => {
  if (Number.isInteger(ci.fromWizardId)) {
    ci.fromWizardId = getUpdatedWizardId(ci.fromVisualizerType, ci.fromWizardId)
  } else if (ci.fromWizardGroupId && wizardState.wizardIsActive && (wizardState.wizardList.length === 1) && ci.cartFeature) {
    const wizardGroupWithCartItemWizGroupId = wizardState.wizardList[0].wizardGroups.find(wg => wg.id === ci.fromWizardGroupId);
    if (wizardGroupWithCartItemWizGroupId && ci.cartFeature.dbFeature && ci.cartFeature.dbFeature.groupName) {
      ci.fromWizardId = wizardState.wizardList[0].id; // we have one wizard and that's the same group, assign it
    }
  }
  return ci
}

/**
 * returns lowercased visualizer (bathroom | kitchen | fireplace) same as in the wizard item depending on wizardItem id
 * @param wizardItem {wizardItemInterface | wizardAllObjectInterface}
 * @param withToolVersion {boolean}
 * @returns {string} bathroom | kitchen | fireplace
 */
export const getWizardVisualizerType = (wizardItem, withToolVersion = false) => {

  let commonName = wizardItem.visualizer;

  if (!commonName) {
    commonName = "kitchen";
    const wizardItemId = wizardItem.id || wizardItem.wizardItemId;
    if (wizardItemId > 3000) {
      commonName = "laundryroom";
    } if (wizardItemId > 2000) {
      commonName = "fireplace";
    } else if (wizardItemId > 1000) {
      commonName = "bathroom";
    }
  }

  if (withToolVersion) {
    const existingSubscription = hasSubscriptionForRoom(commonName, false);
    if (existingSubscription) {
      return getVisualizerTypeFromSubscription(existingSubscription);
    }
    return commonName
  }
  return commonName
}

/**
 * checks if current wizard can be used in the  visualizer
 * @param wizardItem {wizardItemInterface | wizardAllObjectInterface}
 * @param visualizerType {string}
 * @returns {boolean}
 */
export const isSameVisualizerWizard = (wizardItem, visualizerType = getCommonVisualizerType()) => {
  if (wizardItem.visualizer === "all") { // should not ever be here
    return true
  }
  if (wizardItem.visualizer) {
    return wizardItem.visualizer === visualizerType
  }
  return getWizardVisualizerType(wizardItem) === visualizerType
}
